export default __webpack_public_path__ + "static/media/caraccident.06f92916.png";